module.exports = __webpack_public_path__ + "img/Speaker=Franziska Boenisch.11f66d1d.png";